import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Spin, Upload} from 'antd';
import {requestHelper} from 'shj-utils';
import {baseURL} from '@/api';
import styles from './index.module.less';
import _ from 'lodash';
import { getXTransferInsideTenantId } from '@/utils/common';

let ueInstance: any = null;

function getRawUE(): any {
  return (window as any)?.rawWindow?.UE || (window as any).UE;
}

const UEditor = forwardRef((props: any, ref) => {
  const {baseData, onChange, onBlur, fileUrlPrefix, disabled} = props;
  const id = useRef(new Date().getTime() + '').current;
  const imgUploadRef = useRef<any>(null);
  const videoUploadRef = useRef<any>(null);

  const [initFinished, setInitFinished] = useState<boolean>(false);
  useEffect(() => {
    if (!baseData) return;
    ueInstance?.ready(function () {
      ueInstance?.setContent(baseData);
    });
  }, [baseData]);

  useEffect(() => {
    const otherToolbars: string[] = ['addimages', 'addvideo'];

    const toolbars: string[][] = [
      [
        'fullscreen',
        'source',
        'undo', //撤销
        'redo', //重做
        'bold',
        'italic',
        'underline',
        'fontborder',
        'strikethrough',
        'superscript',
        'subscript',
        'removeformat',
        'formatmatch',
        'blockquote',
        'pasteplain',
        'forecolor',
        'backcolor',
        'insertorderedlist',
        'insertunorderedlist',
        'selectall',
        'rowspacingtop',
        'rowspacingbottom',
        'lineheight',
        'paragraph',
        'fontfamily',
        'fontsize',
        'directionalityltr',
        'directionalityrtl',
        'indent',
        'justifyleft', //居左对齐
        'justifyright', //居右对齐
        'justifycenter', //居中对齐
        'justifyjustify', //两端对齐
        'cleardoc',
      ],
      otherToolbars,
    ];
    const UE = getRawUE();
    console.log('readyUE', UE)
    ueInstance = UE?.getEditor?.(id, {
      UEDITOR_HOME_URL: 'https://static.shjmall.cn/UEEditor/',
      themePath: 'https://static.shjmall.cn/UEEditor/themes/',
      serverUrl: '',
      autoFloatEnabled: false,
      elementPathEnabled: false,
      enableAutoSave: true,
      autoHeight: true,
      autoHeightEnabled: true,
      initialFrameWidth: '100%',
      initialFrameHeight: 600,
      zIndex: 9,
      scaleEnabled: true,
      xssFilterRules: false,
      inputXssFilter: false,
      outputXssFilter: false,
      autoClearEmptyNode: false,
      readonly: disabled,
      toolbars: toolbars,
    }); // 页面加载完成后，创建 ueditor, 第二个参数为配置参数

    ueInstance?.ready(function () {
      ueInstance.addListener(
          'contentChange',
          _.debounce(() => {
            onChange && onChange(ueInstance.getContent());
          }, 1000),
      );
      ueInstance.addListener(
          'blur',
          _.debounce(() => {
            onBlur && onBlur(ueInstance.getContent());
          }, 1000),
      );
      //注册按钮执行时的command命令，使用命令默认就会带有回退操作
      ueInstance.registerCommand('addimages', {
        execCommand() {
          imgUploadRef.current.click();
        },
      });
      //注册按钮执行时的command命令，使用命令默认就会带有回退操作
      ueInstance.registerCommand('addvideo', {
        execCommand() {
          videoUploadRef.current.click();
        },
      });
    });

    ueInstance?.addListener('selectionchange', () => {
      const elements = ueInstance.selection.document.querySelectorAll('*[data-component-code]');
      elements.forEach((element: any) => {
        if (element.innerText.trim().length == 0 && element.childNodes.length == 0) {
          element.parentNode?.removeChild(element);
        }
      });
    });

    setInitFinished(true);

    return () => {
      console.log('destroyUE');
      ueInstance?.removeListener('contentChange');
      getRawUE()?.delEditor(id); // 页面离开时销毁，否则 ueditor 会进行缓存
    };
  }, []);

  const delEditorFn = () => {
    const edui_fixedlayer: any = document.getElementById('edui_fixedlayer');
    if (edui_fixedlayer) {
      edui_fixedlayer.remove();
    }
    getRawUE()?.delEditor(id); // 页面离开时销毁，否则 ueditor 会进行缓存
  };

  const uploadChange = (res: any) => {
    console.log('res===>', res)
    if (res?.file?.status === 'done') {
      let url = res?.file?.response.data.relativePath || '';
      if (res?.file?.type?.indexOf('video') > -1) {
        const voideHtml = `<p><video style="width: 100%; height: auto" controls src="${
            fileUrlPrefix + url
        }" preload="metadata" ></video></p>`;
        ueInstance.execCommand('inserthtml', voideHtml);
      } else {
        const imgHtml = `<p style="white-space: normal;"><img alt="" style="max-width: 100%; height: auto" src="${
            fileUrlPrefix + url
        }" /></p>`;
        ueInstance.execCommand('inserthtml', imgHtml);
      }
    }
  };

  useImperativeHandle(ref, () => ({
    delEditorFn,
    ueInstance,
  }));
  return (
      <div className={styles.ue} id={'UE_wrapper'}>
        {initFinished ? null : (
            <div className={styles.initBox}>
              <Spin size="large" tip="编辑器初始化中"/>
            </div>
        )}
        <script style={{width: '100%', height: 800}} id={id} type="text/plain"/>
        <Upload
            showUploadList={false}
            headers={{
              Authorization: requestHelper?.getToken?.()
              ,'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId()
            }}
            accept="image/*"
            action={baseURL + '/file-service/fileStore/upload'}
            onChange={(res) => {
              uploadChange(res);
            }}
        >
          <div style={{display: 'none'}} ref={imgUploadRef}></div>
        </Upload>
        <Upload
            showUploadList={false}
            headers={{
              Authorization: requestHelper?.getToken?.()
              ,'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId()
            }}
            accept="video/*"
            action={baseURL + '/file-service/fileStore/upload'}
            onChange={(res) => {
              uploadChange(res);
            }}
        >
          <div style={{display: 'none'}} ref={videoUploadRef}/>
        </Upload>
      </div>
  );
});

export default UEditor;
